var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('IconLinkItem',_vm._g({key:"export_json",attrs:{"text":"Export as OHDF JSON","icon":"mdi-code-json"},on:{"click":function($event){return _vm.export_json()}}},on))]}}])},[_c('span',[_vm._v("JSON Download")])])
}
var staticRenderFns = []

export { render, staticRenderFns }